<template>
  <div>
    <v-card class="ml-1 mr-1 generic-card" style="border-radius: 20px; margin: 0; margin-top: 5px">
      <template v-if="generic">
        <div class="card-img">
          <uploadfile
            v-model="generic.image_url"
            :height="157"
            data-vv-as="Generic Image"
            :data-vv-name="'generic_manage_' + '_image'"
            @onUploaded="onUploaded"
            v-validate="isValidate ? 'required' : ''"
          ></uploadfile>
          <!-- <uploadfile
            v-model="generic.image_url"
            :height="ratio == 'horizontal' ? 157 : 300"
            data-vv-as="Generic Image"
            :data-vv-name="'generic_manage_' + '_image'"
            @onUploaded="onUploaded"
            v-validate="isValidate ? 'required' : ''"
          ></uploadfile> -->
        </div>
        <div
          :class="{ 'has-error': errors.has('generic_manage_' + '_image') }"
          style="padding: 0 10px"
        >
          <span class="error--text caption" v-show="errors.has('generic_manage_' + '_image')">{{
            errors.first('generic_manage_' + '_image')
          }}</span>
        </div>

        <div class="card-body">
          <div
            :class="{ 'has-error': errors.has('generic_manage_' + '_title') }"
            style="padding: 5px"
          >
            <textarea
              name="title"
              id="title"
              style="width: 100%; resize: none; height: 50px; font-weight: 600; border-radius: 2px 2px 2px 0px !important;"
              maxlength="80"
              :data-vv-as="$t('Title')"
              :data-vv-name="'generic_manage_' + '_title'"
              class="form-control"
              v-model="generic.title"
              :placeholder="$t('Enter Title')"
              @change="$emit('input', generic)"
              v-validate="isValidate ? 'required' : ''"
            ></textarea>
            <span class="error--text caption" v-show="errors.has('generic_manage_' + '_title')">{{
              errors.first('generic_manage_' + '_title')
            }}</span>
          </div>
        </div>
      </template>

      <ul v-if="generic" class="list-group list-group-flush" style="margin-bottom: 0px">
        <li
          class="list-group-item"
          style="
            border-left: none;
            border-right: none;
            border-bottom: none;
            border-top: 1px solid #eee;
            border-radius: 0px;
            text-align: center;
          "
        ></li>
        <li
          class="list-group-item"
          style="
            border-left: none;
            border-right: none;
            border-bottom: none;
            border-top: 1px solid #eee;
            border-radius: 0px;
            text-align: center;
          "
        >
          <div style="padding: 10px 0">
            <span class="primary--text" style="padding: 15px 0; display: inline">
              {{ btnValueToText(generic.notification_messages_cta_text) }}
            </span>
            <v-icon class="primary--text" style="cursor: pointer" @click="editBtn = true"
              >edit</v-icon
            >
          </div>
        </li>
      </ul>
    </v-card>
    <v-dialog v-model="editBtn" persistent max-width="600px">
      <v-card>
        <v-card-text>
          <v-layout warp>
            <v-flex>
              <h3>{{ $t('select_button') }}</h3>
            </v-flex>
            <v-flex class="text-xs-right">
              <!-- <v-btn flat icon small fab @click="editBtn = false">
                <v-icon>close</v-icon>
              </v-btn> -->
            </v-flex>
          </v-layout>

          <div class="text-xs-center">
            <v-radio-group
              color="primary"
              @select="onSelectedNotificationMessagesText"
              v-model="generic.notification_messages_cta_text"
              row
              class="text-xs-center"
            >
              <v-radio
                class="pa-2"
                color="primary"
                :label="$t('get_messages')"
                :value="'GET'"
              ></v-radio>
              <v-radio
                class="pa-2"
                color="primary"
                :label="$t('sign_up_for_messages')"
                :value="'SIGN_UP'"
              ></v-radio>
              <v-radio
                class="pa-2"
                color="primary"
                :label="$t('allow_messages')"
                :value="'ALLOW'"
              ></v-radio>
              <v-radio
                class="pa-2"
                color="primary"
                :label="$t('opt_in_to_messages')"
                :value="'OPT_IN'"
              ></v-radio>
              <v-radio
                class="pa-2"
                color="primary"
                :label="$t('get_daily_messages')"
                :value="'FREQUENCY'"
              ></v-radio>
            </v-radio-group>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" depressed @click="onSave">{{ $t('Save') }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showModal" persistent max-width="600px">
      <v-card>
        <div class="text-xs-right">
          <v-spacer></v-spacer>
          <v-btn flat icon small fab @click="showModal = false">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <h3>{{ $t('Link image url') }}</h3>
          <div class="text-xs-center">
            <v-radio-group
              color="primary"
              @select="onSelected"
              v-model="generic.notification_messages_frequency"
              row
              class="text-xs-center"
            >
              <v-radio color="primary" :label="$t('DAILY')" :value="'DAILY'"></v-radio>
              <v-radio color="primary" :label="$t('WEEKLY')" :value="'WEEKLY'"></v-radio>
              <v-radio color="primary" :label="$t('MONTHLY')" :value="'MONTHLY'"></v-radio>
            </v-radio-group>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" depressed @click="onSave">{{ $t('Save') }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import specialtext from '@/components/elements/specialtext'
import uploadfile from '@/components/elements/uploadfile'
import Multiselect from 'vue-multiselect'

export default {
  inject: ['$validator'],
  components: {
    specialtext,
    Multiselect,
    uploadfile
  },
  props: {
    value: {
      default: {}
    },
    isValidate: {
      default: false,
      type: Boolean
    },
    ratio: {
      default: 'square'
    }
  },
  data: function() {
    return {
      btnOptions: [
        {
          value: 'DAILY'
        },
        {
          value: 'WEEKLY'
        },
        {
          value: 'MONTHLY'
        }
      ],
      editBtn: false,
      linktype: 'none',
      linkurl: '',
      isProductview: false,
      generic: this.value,
      showModal: false
    }
  },
  mounted: function() {
    this.generic.notification_messages_frequency = 'DAILY'
    if (!this.generic.notification_messages_cta_text) {
      this.generic.notification_messages_cta_text = 'GET'
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  methods: {
    btnValueToText(value) {
      const vm = this
      if (value === 'GET') {
        return vm.$t('get_messages')
      } else if (value === 'SIGN_UP') {
        return vm.$t('sign_up_for_messages')
      } else if (value === 'ALLOW') {
        return vm.$t('allow_messages')
      } else if (value === 'OPT_IN') {
        return vm.$t('opt_in_to_messages')
      } else if (value === 'FREQUENCY') {
        return vm.$t('get_daily_messages')
      } else {
        return value
      }
    },
    onSelectedNotificationMessagesText(param) {
      this.generic.notification_messages_cta_text = param
    },
    onSelected(param) {
      this.generic.notification_messages_frequency = param
    },

    onUploaded(url) {
      if (this.linktype == 'imglink') {
        this.$set(this.generic, 'default_action', {
          type: 'web_url',
          url: url
        })
        this.linkurl = url
      }
      this.$emit('onSave', this.generic)
    },

    onSave: function() {
      this.$emit('onSave', this.generic)
      this.showModal = false
      this.editBtn = false
    }
  },
  watch: {
    value: function() {
      this.generic = this.value
    }
  }
}
</script>

<style scoped>
.card-img {
  overflow: hidden !important;
}
</style>



// WEBPACK FOOTER //
// src/components/elements/NtnManage.vue